import { Skeleton, Statistic } from 'antd'

import { classNames } from '@/Ship/Helpers/classNames'

import styles from './Overview/Overview.module.css'

/** Стан помилки: число невідоме — прочерк, а не старе значення (Н-3). */
export const UNKNOWN_TILE_VALUE = '—'

interface DashboardStatTileProps {
    tile: string
    title: string
    value: number | string | null | undefined
    loading: boolean
    /** Колір значення — лише токеном теми (`theme.useToken()`), щоб темна тема його бачила. */
    color?: string
}

/**
 * Одне число в блоці «Робочого столу» (`SPEC-015` §5.3): підпис дрібно над
 * значенням, без власної рамки — блоком є `Panel`, що їх збирає в сітку
 * (`Overview.module.css`, `.stats`). Підпис обрізається трикрапкою, повний —
 * у підказці. Клік нічого не робить.
 */
export const DashboardStatTile = ({ tile, title, value, loading, color }: DashboardStatTileProps) => (
    <div className={classNames(styles['stat'])} data-tile={tile} title={title}>
        {loading ? (
            <Skeleton active title={false} paragraph={{ rows: 2, width: ['80%', '40%'] }} />
        ) : (
            <Statistic
                title={title}
                value={value ?? UNKNOWN_TILE_VALUE}
                {...(color && value !== null && value !== undefined ? { styles: { content: { color } } } : {})}
            />
        )}
    </div>
)

/** Сітка чисел блоку: три чи шість у ряд на широкому екрані, менше — на вузькому. */
export const StatGrid = ({ columns, children }: { columns: 3 | 6; children: React.ReactNode }) => (
    <div className={classNames(styles['stats'], styles[columns === 6 ? 'cols6' : 'cols3'])}>{children}</div>
)
